import React from "react";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const CustomDateRangePicker = ({ value, onChange }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-5 w-full">
      <DatePicker
        label="Start Date"
        value={value.startDate}
        onChange={(newValue) => onChange({ ...value, startDate: newValue })}
        slotProps={{
          textField: {
            variant: "outlined",
            size: "small",
            fullWidth: true,
          },
        }}
      />
      <DatePicker className=""
        label="End Date"
        value={value.endDate}
        onChange={(newValue) => onChange({ ...value, endDate: newValue })}
        slotProps={{
          textField: {
            variant: "outlined",
            size: "small",
            fullWidth: true,
          },
        }}
      />
    </div>
  );
};

export default CustomDateRangePicker;
